import { SafeHtml } from '@angular/platform-browser';
import { ERROR_CODES, ErrorMessages } from './error-messages.model';

export class ErrCode {
  constructor(
    public code: number,
    public msg?: string | SafeHtml,
    public data?: any,
    public isCustomMsg?: boolean,
  ) {
    if (!msg && ErrorMessages[code]) {
      this.msg = ErrorMessages[code];
    }
  }

  public static fromError(e: Error): ErrCode {
    return new ErrCode(ERROR_CODES.GENERIC_ERROR, e.message);
  }

  public static fromApiLegacy(e: any): ErrCode {
    if (e.error_code) {
      return new ErrCode(e.error_code, e.error_msg, e.data);
    } else {
      return new ErrCode(ERROR_CODES.GENERIC_ERROR);
    }
  }

  public static fromException(e: any, ctx?: string): ErrCode {
    const err = new Error();
    console.error(`ErrCode.fromException call stack ${err.stack}`);
    if (e instanceof ErrCode) {
      return e;
    } else if (e.status > 0) {
      return new ErrCode(e.status, e.error.message);
    } else if (e.code > 0) {
      return new ErrCode(e.code, e.msg);
    } else if (e instanceof Error) {
      return ErrCode.fromError(e);
    } else if (e.error_code) {
      return ErrCode.fromApiLegacy(e);
    } else {
      if (ctx) {
        return new ErrCode(ERROR_CODES.GENERIC_ERROR, ctx);
      } else {
        return new ErrCode(ERROR_CODES.GENERIC_ERROR, 'An unknown error occurred');
      }
    }
  }
}
